import { ModuleFE_EHRInstance } from './ModuleFE_EHRInstance.js';
export const ModulePackFE_EHRInstance = [ModuleFE_EHRInstance];
//# sourceMappingURL=module-pack.js.map